// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/group_class_attendance/v1/group_class_attendance.proto (package fingertip.creator.group_class_attendance.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BoolValue, proto3 } from "@bufbuild/protobuf";
import { GroupClassAttendanceStatus } from "../../../common/enum/v1/group_class_attendance_status_pb.js";
import { GroupClass } from "../../../common/type/v1/group_class_pb.js";
import { GroupClassAttendance } from "../../../common/type/v1/group_class_attendance_pb.js";
import { SiteContact } from "../../../common/type/v1/site_contact_pb.js";
import { EventType } from "../../../common/type/v1/event_type_pb.js";
import { StorePayment } from "../../../common/type/v1/store_payment_pb.js";
import { StoreInvoice } from "../../../common/type/v1/store_invoice_pb.js";
import { PaymentTotals } from "../../../common/type/v1/payment_totals_pb.js";

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.UpdateGroupClassAttendanceRequest
 */
export const UpdateGroupClassAttendanceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.UpdateGroupClassAttendanceRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_class_attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(GroupClassAttendanceStatus) },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.UpdateGroupClassAttendanceResponse
 */
export const UpdateGroupClassAttendanceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.UpdateGroupClassAttendanceResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.DeleteGroupClassAttendanceRequest
 */
export const DeleteGroupClassAttendanceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.DeleteGroupClassAttendanceRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_class_attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.DeleteGroupClassAttendanceResponse
 */
export const DeleteGroupClassAttendanceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.DeleteGroupClassAttendanceResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.GetGroupClassAttendanceRequest
 */
export const GetGroupClassAttendanceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.GetGroupClassAttendanceRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_class_attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.GetGroupClassAttendanceResponse
 */
export const GetGroupClassAttendanceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.GetGroupClassAttendanceResponse",
  () => [
    { no: 1, name: "group_class", kind: "message", T: GroupClass },
    { no: 2, name: "attendance", kind: "message", T: GroupClassAttendance },
    { no: 3, name: "contact", kind: "message", T: SiteContact },
    { no: 4, name: "event_type", kind: "message", T: EventType },
    { no: 5, name: "payments", kind: "message", T: StorePayment, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.GetGroupClassAttendancePublicRequest
 */
export const GetGroupClassAttendancePublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.GetGroupClassAttendancePublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_class_attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.GetGroupClassAttendancePublicResponse
 */
export const GetGroupClassAttendancePublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.GetGroupClassAttendancePublicResponse",
  () => [
    { no: 1, name: "group_class", kind: "message", T: GroupClass },
    { no: 2, name: "attendance", kind: "message", T: GroupClassAttendance },
    { no: 3, name: "contact", kind: "message", T: SiteContact },
    { no: 4, name: "event_type", kind: "message", T: EventType },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.CompleteGroupClassAttendanceRequest
 */
export const CompleteGroupClassAttendanceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.CompleteGroupClassAttendanceRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "no_show", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "charge_amount_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.CompleteGroupClassAttendanceResponse
 */
export const CompleteGroupClassAttendanceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.CompleteGroupClassAttendanceResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.CancelGroupClassAttendanceRequest
 */
export const CancelGroupClassAttendanceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.CancelGroupClassAttendanceRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cancellation_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "charge_cancellation_fee", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.CancelGroupClassAttendanceResponse
 */
export const CancelGroupClassAttendanceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.CancelGroupClassAttendanceResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.CancelGroupClassAttendancePublicRequest
 */
export const CancelGroupClassAttendancePublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.CancelGroupClassAttendancePublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.CancelGroupClassAttendancePublicResponse
 */
export const CancelGroupClassAttendancePublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.CancelGroupClassAttendancePublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.AcceptWaitlistedRequest
 */
export const AcceptWaitlistedRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.AcceptWaitlistedRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.AcceptWaitlistedResponse
 */
export const AcceptWaitlistedResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.AcceptWaitlistedResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "attendance", kind: "message", T: GroupClassAttendance },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.RejectWaitlistedRequest
 */
export const RejectWaitlistedRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.RejectWaitlistedRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.RejectWaitlistedResponse
 */
export const RejectWaitlistedResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.RejectWaitlistedResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "attendance", kind: "message", T: GroupClassAttendance },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.GetWaitlistItemsRequest
 */
export const GetWaitlistItemsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.GetWaitlistItemsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.WaitlistItem
 */
export const WaitlistItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.WaitlistItem",
  () => [
    { no: 1, name: "attendance", kind: "message", T: GroupClassAttendance },
    { no: 2, name: "contact", kind: "message", T: SiteContact },
    { no: 3, name: "group_class", kind: "message", T: GroupClass },
    { no: 4, name: "event_type", kind: "message", T: EventType },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.GetWaitlistItemsResponse
 */
export const GetWaitlistItemsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.GetWaitlistItemsResponse",
  () => [
    { no: 1, name: "items", kind: "message", T: WaitlistItem, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.SavedPaymentMethod
 */
export const SavedPaymentMethod = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.SavedPaymentMethod",
  () => [
    { no: 1, name: "payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "last4", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.GetAttendancePaymentDetailsPublicRequest
 */
export const GetAttendancePaymentDetailsPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.GetAttendancePaymentDetailsPublicRequest",
  () => [
    { no: 1, name: "attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.GetAttendancePaymentDetailsPublicResponse
 */
export const GetAttendancePaymentDetailsPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.GetAttendancePaymentDetailsPublicResponse",
  () => [
    { no: 1, name: "group_class", kind: "message", T: GroupClass },
    { no: 2, name: "attendance", kind: "message", T: GroupClassAttendance },
    { no: 3, name: "contacts", kind: "message", T: SiteContact, repeated: true },
    { no: 4, name: "primary_contact", kind: "message", T: SiteContact },
    { no: 5, name: "event_type", kind: "message", T: EventType },
    { no: 6, name: "invoice", kind: "message", T: StoreInvoice },
    { no: 7, name: "deposit_totals", kind: "message", T: PaymentTotals },
    { no: 8, name: "non_deposit_totals", kind: "message", T: PaymentTotals },
    { no: 9, name: "pending_deposit", kind: "message", T: BoolValue },
    { no: 10, name: "saved_payment_method", kind: "message", T: SavedPaymentMethod },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.ConfirmAttendanceRequestPublicRequest
 */
export const ConfirmAttendanceRequestPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.ConfirmAttendanceRequestPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "form_response_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class_attendance.v1.ConfirmAttendanceRequestPublicResponse
 */
export const ConfirmAttendanceRequestPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class_attendance.v1.ConfirmAttendanceRequestPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

